<template>
  <section>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <btns @exec="exec"></btns>
   
    <div class="data-container scroll-table">
      <!-- 回收站详情 -->
      <el-table
        :data="tableData"
        border
        class="mgt-18"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="customerName" label="品牌">
        </el-table-column>
        <el-table-column prop="customerName" label="已出库存数">
        </el-table-column>
        <el-table-column prop="customerName" label="次品数"> </el-table-column>
        <el-table-column prop="customerName" label="在途库存数">
        </el-table-column>
        <el-table-column prop="customerName" label="当前库存数">
        </el-table-column>
        <el-table-column prop="customerName" label="累计库存数">
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        class="mgt-10 pd-0"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="searchForm.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchForm.totalCount"
      >
      </el-pagination> -->
    </div>
  </section>
</template>

<script>
import btns from "@/components/btns.vue";
import breadcrumbs from "@/components/breadcrumbs.vue";
import Button from "../sys/button.vue";

export default {
  components: {
    btns,
    breadcrumbs,
  },
  data() {
    return {
      tableData: [],
      tableSelection: [],
    };
  },
  created() {
    this.query();
  },
  methods: {
    handleSizeChange(v) {
      this.searchForm.size = v;
      this.query();
    },
    handleCurrentChange(v) {
      this.searchForm.current = v;
      this.query();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.search();
    },
    query() {
      //获取接口
      this.$api.backstop
        .getHouseBackStopInfo(this.searchForm)
        .then((d) => {
          if (d.code == 200) {
            this.tableData = d.data;
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
   
  },
};
</script>
<style scoped lang='less'>

.font36 {
  font-size: 36px;
  margin-right: 5px;
}
.row{
  padding: 10px;
  min-height: 35px;
  box-sizing: border-box;
  border: 1px solid var(--table-border);
}
.flex1{
  flex:1;
  text-align: center;
}
.border-8e{
  border: 1px solid var(--table-border);
}
</style>